<!--
  Meus dados — a própria pessoa preenche os dados pessoais (CPF, endereço, RG…) no perfil
  (chamado New Shoes 2026-0079, F2). São os mesmos da implantação e do contrato de franquia.
  Nome de login, e-mail e idioma ficam como estão (Cognito).
-->
<template>
  <section class="meus-dados" data-testid="perfil-meus-dados">
    <div class="topo">
      <h3>{{ t('Meus dados') }}</h3>
      <span v-if="carregado && faltando.length" class="chip-falta" data-testid="perfil-faltando">{{ t('Faltam campos obrigatórios') }}: {{ faltando.length }}</span>
    </div>
    <p class="quieto">{{ t('Usados no contrato de franquia e no onboarding. Só você e a franqueadora veem.') }}</p>
    <p v-if="!carregado" class="quieto">{{ t('Carregando…') }}</p>
    <template v-else>
      <formulario-de-dados v-model="valores" formulario="dados_pessoais" />
      <div class="botoes">
        <app-button :label="t('Salvar meus dados')" icon="pi pi-save" :loading="salvando" :disabled="!mudou" data-testid="perfil-salvar" @click="salvarDados" />
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import FormularioDeDados from '../implantacao/FormularioDeDados.vue';
import type { Valores } from '../implantacao/camposDosDados';
import { usePerfil } from '../../composables/usePerfil';
import { mensagemDaRecusa } from '../../composables/useImplantacao';
import { eventBus } from '../../eventBus';

const { t } = useI18n();
const { dados, faltando, carregar, salvar } = usePerfil();
const valores = ref<Valores>({});
const carregado = ref(false);
const salvando = ref(false);

const igualAoGravado = (): Valores => ({ ...(dados.value ?? {}) });
const mudou = computed(() => JSON.stringify(valores.value) !== JSON.stringify(igualAoGravado()));

const salvarDados = async (): Promise<void> => {
  salvando.value = true;
  try {
    await salvar(Object.fromEntries(Object.entries(valores.value).map(([k, v]) => [k, v ?? null])));
    valores.value = igualAoGravado();
    eventBus.emit('globalMessage.success', t('Dados salvos'));
  } catch (e) {
    eventBus.emit('globalMessage.error', t(mensagemDaRecusa(e)));
  } finally {
    salvando.value = false;
  }
};

onMounted(async () => {
  try {
    await carregar();
    valores.value = igualAoGravado();
  } catch (e) {
    eventBus.emit('globalMessage.error', t(mensagemDaRecusa(e)));
  } finally {
    carregado.value = true;
  }
});
</script>

<style scoped>
.meus-dados { display: flex; flex-direction: column; gap: 12px; margin-top: 16px; padding-top: 16px; border-top: 1px solid #edebe5; }
.topo { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; }
.topo h3 { margin: 0; }
.chip-falta { padding: 3px 10px; border-radius: 999px; background: #fcefc2; color: #6b4600; font-weight: 700; font-size: 13px; }
.quieto { color: #5b6168; margin: 0; font-size: 14px; }
.botoes { display: flex; gap: 8px; }
</style>
